import { useState } from 'react';
import { Button, Form, Input } from "antd";
import brandsStorage from "../storages/brands";
import UploadImage from "../components/upload-image";

/* eslint-disable-next-line */
export interface AddBrandFormProps {
  onSubmitted: () => void;
}

export function AddBrandForm(
  {
    onSubmitted,
  }: AddBrandFormProps) {
  const [brandName, setBrandName] = useState('');
  const [image, setImage] = useState<string>('');
  const [siteUrl, setSiteUrl] = useState<string>('');

  return (
    <div>
      <Form>
        <Form.Item label="Name">
          <Input
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="Url">
          <Input
            value={siteUrl}
            onChange={(e) => setSiteUrl(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="Logo">
          <UploadImage
            image={image}
            setImage={setImage}
          />
          {image && (
            <Button
              type="primary"
              onClick={() => {
                setImage('');
              }}
            >
              Remove
            </Button>
          )}
        </Form.Item>
        {image && brandName && (
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => {
              brandsStorage.addBrand({
                name: brandName,
                logoUrl: image,
                siteUrl,
              })
            }}
          >
            Save
          </Button>
        )}
      </Form>
    </div>
  );
}

export default AddBrandForm;
